// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"968a72ca","103":"e2492e06","107":"2be7e068","184":"55dcafbe","453":"643472a0","508":"0264eccd","981":"15f08732"}[chunkId] + ".chunk.js";
};